function FooterSection() {
  return (
    <footer className="footer">
      <div>
        <h3>GURU KRIPA Services & Repairs</h3>
        <p>
          Trusted local experts for appliance repair, cleaning, and electrical
          solutions.
        </p>
      </div>
      <div className="footer-links">
        <a href="#featured">AC Services</a>
        <a href="#services">Services</a>
        <a href="#cleaning">Cleaning</a>
        <a href="#why">Why Us</a>
        <a href="#contact">Contact</a>
      </div>
      <p className="footer-copy">© 2026 GURU KRIPA. All rights reserved.</p>
      <p className="footer-dev">
        Developer: Ankit Kumar |{" "}
        <a href="mailto:ankitsharma97096@gmail.com">ankitsharma97096@gmail.com</a>
      </p>
    </footer>
  );
}

export default FooterSection;
